// @flow
import _format from 'date-fns/format';
import isValid from 'date-fns/is_valid';
import da from 'date-fns/locale/da';

export function format(date: Date, formatStr: string) {
  return date && isValid(date)
    ? _format(date, formatStr, { locale: da })
    : null;
}
